<template>
  <tr class="user-item">
    <div class="border-left" v-if="expand"></div>
    <td>
      <label :for="`checkbox_${dataUser.id}`">
        <input
          type="checkbox"
          :id="`checkbox_${dataUser.id}`"
          class="filled-in"
          @change="updateSelectedRows"
          :checked="dataSelectedRows.includes(dataUser.id)"
        />
        <span></span>
      </label>
    </td>
    <td><div @click="expand = !expand" class="user-title">{{ `${dataUser.first_name} ${dataUser.last_name}` }}</div></td>
    <td>{{ dataUser.email }}</td>
    <td>{{ competitionEntry.name_of_school || "-" }}</td>
    <td>{{ competitionEntry.school_form || "-" }}</td>
    <!-- <td>{{ dataUser.acf.verified }}</td> -->
    <td>
      {{
        formatDate(dataUser.acf.last_login, "MMM DD, YYYY") || "Haven't login"
      }}
    </td>
    <td class="action-col">
      <button
        @click="expand = !expand"
        class="btn-flat btn-floating btn-expand waves-effect waves-black"
      >
        <i class="material-icons black-text">{{
          expand ? "expand_less" : "expand_more"
        }}</i>
      </button>
    </td>

    <div class="more-info" :class="{ expand: expand }">
      <div class="sub-grid">
        <div class="sub-item" v-for="(row, index) in 3" :key="`row_${row}`">
          <div class="sub-item-grid" v-if="index + 1 <= detailsColOne.length">
            <div class="details-content">
              <div class="content-title grey-text text-darken-1">
                {{ detailsColOne[index].title }}
              </div>
              <div
                class="content-text"
                :class="`${detailsColOne[index]}-text`"
                v-html="detailsColOne[index].value"
              ></div>
            </div>
          </div>
          <div class="sub-item-grid" v-if="index + 1 <= detailsColTwo.length">
            <div class="details-content">
              <div class="content-title grey-text text-darken-1">
                {{ detailsColTwo[index].title }}
              </div>
              <div
                class="content-text"
                :class="`${detailsColTwo[index]}-text`"
                v-html="detailsColTwo[index].value"
              ></div>
            </div>
          </div>
          <div class="sub-item-grid" v-if="index + 1 <= detailsColThree.length">
            <div class="details-content">
              <div class="content-title grey-text text-darken-1">
                {{ detailsColThree[index].title }}
              </div>
              <div
                class="content-text"
                :class="`${detailsColThree[index]}-text`"
                v-html="detailsColThree[index].value"
              ></div>
            </div>
          </div>
          <div class="sub-item-grid" v-if="index + 1 <= detailsColFour.length">
            <div class="details-content">
              <div class="content-title grey-text text-darken-1">
                {{ detailsColFour[index].title }}
              </div>
              <div
                class="content-text"
                :class="`${detailsColFour[index]}-text`"
                v-html="detailsColFour[index].value"
              ></div>
            </div>
          </div>
        </div>
      </div>
      <div class="actions">
        <button @click="openModal()" class="btn-flat amber accent-4 white-text">
          Message
        </button>

        <router-link
          :to="{ name: 'userView', params: { id: dataUser.id } }"
          class="btn-flat indigo accent-2 white-text"
        >
          View
        </router-link>
      </div>
    </div>
  </tr>
</template>

<script>
import dayjs from "dayjs";

export default {
  name: "userItem",
  props: {
    dataUser: {
      required: true,
      type: Object,
    },
    dataSelectedRows: {
      required: true,
      type: Array,
    },
  },
  data() {
    return {
      expand: false,
    };
  },
  computed: {
    competitionEntry() {
      if (!this.dataUser.acf.competition_entry) return {};
      const val = JSON.parse(this.dataUser.acf.competition_entry);
      return val;
    },
    homeProfileProgress() {
      const typeValCheck = (x) => {
        let condition_1 =
          (x && Array.isArray(x) && x.length > 0) ||
          (x && !Array.isArray(x) & (x !== "") && x !== null)
            ? true
            : false;
        /* 	let condition_3 =  !condition_1 && !condition_2 && x ? true : false */
        return condition_1;
      };
      let hp =
        this.dataUser.acf.home_profile !== "" && this.dataUser.acf.home_profile
          ? JSON.parse(this.dataUser.acf.home_profile)
          : false;

      if (hp) {
        const val =
          (Object.values(hp).filter((x) => typeValCheck(x)).length /
            Object.values(hp).length) *
          100;

        return val ? `${val.toFixed(0)}% Completed` : "Not Yet Started";
      } else {
        return "-";
      }
    },

    detailsColOne() {
      return [
        {
          title: "Name",
          value: `${this.dataUser.first_name} ${this.dataUser.last_name}`,
        },
        {
          title: "Email",
          value: this.dataUser.email,
        },
        {
          title: "Gender",
          value: this.competitionEntry.gender
            ? this.competitionEntry.gender
            : "-",
        },
      ];
    },
    detailsColTwo() {
      return [
        {
          title: "Date Joined",
          value: this.formatDate(
           new Date( this.dataUser.registered_date),
            "MMMM DD, YYYY"
          ),
        },
        {
          title: "Last Login",
          value: this.dataUser.acf.last_login
            ? this.formatDate(new Date(this.dataUser.acf.last_login), "DD, MMMM YYYY")
            : "Haven't login",
        },
        {
          title: "Email Verified",
          value: this.dataUser.acf.verified
            ? "<i class='material-icons-outlined amber-text text-accent-4'>task_alt</i>"
            : "<i class='material-icons-outlined red-text text-lighten-1'>cancel</i>",
        },
      ];
    },
    detailsColThree() {
      return [
        {
          title: "School",
          value: this.competitionEntry.name_of_school || "-",
        },
        {
          title: "Form",
          value: this.competitionEntry.school_form || "-",
        },
        {
          title: "Resource Teacher",
          value: this.competitionEntry.resource_teacher || "-",
        },
      ];
    },
    detailsColFour() {
      return [
        {
          title: "Submitted Entry",
          value: this.competitionEntry.submitted
            ? "<i class='material-icons-outlined amber-text text-accent-4'>task_alt</i>"
            : "<i class='material-icons-outlined red-text text-lighten-1'>cancel</i>",
        },
        {
          title: "Home Profile %",
          value: this.homeProfileProgress,
        },
        {
          title: "Generated Surveys PDF",
          value: this.dataUser.acf.pdf
            ? "<i class='material-icons-outlined amber-text text-accent-4'>task_alt</i>"
            : "<i class='material-icons-outlined red-text text-lighten-1'>cancel</i>",
        },
      ];
    },
  },
  methods: {
    updateSelectedRows({ target }) {
      this.$emit("update", { id: this.dataUser.id, checked: target.checked });
    },
    formatDate(date, format) {
      if (!date) return;
      return dayjs(date).format(format);
    },
    openModal() {
      this.$emit("open", this.dataUser.email);
    },
  },
};
</script>
<style lang="scss" scoped>
.user-item {
  position: relative;
  .user-title {
    cursor: pointer;
  }
  .border-left {
    position: absolute;
    left: 0;
    width: 2px;
    height: 100%;
    border-left: 2px solid #536dfe;
  }

  grid-template-rows: auto auto;
  grid-auto-flow: row;
  .btn-expand {
    background: transparent !important;
    border-radius: 50%;
  }

  td {
    padding: 10px 5px !important;
    align-self: center;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;

    &.action-col {
      text-align: center;
    }
    &:first-of-type {
      justify-self: center;
      span {
        display: inline;
      }
    }
  }

  .more-info {
    overflow: hidden;
    background: #f5f5f5;
    grid-row: 2/3;
    grid-column: 1/8;
    max-height: 0;
    transition: all 200ms;
    display: grid;
    grid-template-columns: 50px 1fr 120px;
    &.expand {
      padding: 10px 0px;
      max-height: 500px;
      border-top: 1px solid rgba(0, 0, 0, 0.12);
      transition: max-height 200ms;
    }
    .sub-grid {
      grid-column: 2/3;
      display: grid;
      grid-template-rows: auto;

      .sub-item {
        display: grid;
        grid-template-columns: 1fr 1fr 2fr 240px;
        margin-top: 10px;
        :first-of-type {
          margin-top: 0 !important;
        }

        .sub-item-grid {
          padding: 5px;

          .details-content {
            .content-title {
              font-weight: 600;
            }
            .content-text {
              margin-top: 5px;
              word-break: break-word;
            }

            .Gender-text {
              text-transform: capitalize;
            }
          }
        }
      }
    }

    .actions {
      padding: 0 5px;
      align-self: flex-end;

      a,
      button {
        text-align: center;
        margin-top: 10px;
        width: 100% !important;
      }
    }
  }
}
</style>
